import { ActionTypes } from "../constants/action-types";

export const eventRowReducer = (state = null, action) => {
    switch (action.type) {
      case 'SET_EVENT_ROW_DATA':
        return action.payload;
      default:
        return state;
    }
  };